import axios from "axios";
// const apiUrl = process.env.REACT_APP_API_URL || '';


//get all watches with token materials
const getAllWatches = async () => {

    const token = localStorage.getItem('token');
    // console.log("watchservice has token of: " + token)


    const response = await axios.get(`https://www.kipmate.com/sortyourkip/api/media/getwatches`, {
        headers: {
            Authorization: `${token}`
        },
    });

    return response.data
}


const watchService = { getAllWatches }

export default watchService;
